export const DataField = ({ label, value, icon: Icon }) => (
  <div className="flex flex-col gap-1 rounded-xl border border-transparent px-3 py-2 transition-colors hover:border-slate-100 hover:bg-slate-50">
    <div className="flex items-center gap-2">
      {Icon && <Icon size={14} className="text-slate-400" />}
      <span className="font-inter text-[10px] font-black uppercase tracking-[0.1em] text-slate-400">
        {label}
      </span>
    </div>
    <span className="font-manrope text-sm font-bold text-slate-800">
      {value || "---"}
    </span>
  </div>
);
